/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pinned_Voices_LabelInputs */

const en_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinned Voices`)
};

const fr_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix epinglees`)
};

const de_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angeheftete Stimmen`)
};

const it_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci bloccate`)
};

const ru_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрепленные голоса`)
};

const es_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces fijadas`)
};

const zh_cn2_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置顶的声音`)
};

const ja_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定された音声`)
};

const hi_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिन की गई आवाज़ें`)
};

const pt_pt2_voice_manager_pinned_voices_label = /** @type {(inputs: Voice_Manager_Pinned_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vozes Fixadas`)
};

/**
* | output |
* | --- |
* | "Pinned Voices" |
*
* @param {Voice_Manager_Pinned_Voices_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pinned_voices_label = /** @type {((inputs?: Voice_Manager_Pinned_Voices_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pinned_Voices_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_pinned_voices_label(inputs)
	if (locale === "de") return de_voice_manager_pinned_voices_label(inputs)
	if (locale === "it") return it_voice_manager_pinned_voices_label(inputs)
	if (locale === "ru") return ru_voice_manager_pinned_voices_label(inputs)
	if (locale === "es") return es_voice_manager_pinned_voices_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_pinned_voices_label(inputs)
	if (locale === "ja") return ja_voice_manager_pinned_voices_label(inputs)
	if (locale === "hi") return hi_voice_manager_pinned_voices_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_pinned_voices_label(inputs)
	return en_voice_manager_pinned_voices_label(inputs)
});